import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Dialog,
  IconButton,
  DialogContent,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as CloseIcon } from "../../Assets/Icons/CloseIcon.svg";
import TimerIcon from "@mui/icons-material/Timer";
import InfoIcon from "@mui/icons-material/Info";

const useStyle = makeStyles((theme) => ({
  rsDialog: {
    display: "flex",
    alignItems: "center",
    height: "100px",
    padding: "1rem",
    background: "#fff",
    borderRadius: "20px !important",
    marginTop: "15px",
    marginRight: "15px",
    marginLeft: "15px",
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
    maxWidth: "500px",
    // position: "absolute",
    // top: 0,
    // left: "670px"
    [theme.breakpoints.down(1101)]: {
      position: "relative",
      marginBottom: "20px",
      "&::before": {
        display: "none", // Hides the before element
      },
    },
  },
  info: {
    height: "40px !important",
    width: "40px !important",
    [theme.breakpoints.down(1101)]: {
      height: "35px !important",
      width: "35px !important",
    },
  },
  closeIconBtn: {
    "&>button": {
      padding: "0px",
    },
    "&>svg": {
      width: "15px",
      height: "15px",
    },
  },
  infoText: {
    padding: "10px",
    [theme.breakpoints.down(1101)]: {
      fontSize: "0.8rem !important",
    },
  },
}));

const AutoLogOutInfoBox = (props) => {
  const { open, setOpen } = props;
  const classes = useStyle();

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem("LogoutFromFunc", JSON.stringify(false));
  };

  return (
    <Box className={classes.rsDialog} open={open}>
      <InfoIcon className={classes.info} />
      <Typography color={"black"} className={classes.infoText}>
        We logged you out because you were inactive for 2 hours — it's to help
        keep your account secure.
      </Typography>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        className={classes.closeIconBtn}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default AutoLogOutInfoBox;
